/*
 * @Author: xuejian3721
 * @Date: 2023-09-14 16:41:49
 * @LastEditors: xuejian3721
 * @LastEditTime: 2026-01-06 14:27:05
 */
import Vue from 'vue'
import Vuex from 'vuex'
import chatStore from './modules/chat/index.js'
import uaParser from 'ua-parser-js'
import { parseHashQuerys } from '@/utils/location'
import themes from '@/utils/theme'
import { setGrayscaleData, setGrayscaleMark, setGrayscaleMarkValue } from '@/utils/auth'

const hashQuerys = parseHashQuerys()
const defaultTheme = themes.jzt

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    online: window.navigator.onLine,
    mobile: false,
    pageIsVisible: document.hidden,
    // 是否为pop页面
    isPop: hashQuerys.pop == 1,
    // 是否开启websocket
    isWs: hashQuerys.ws == 1,
    // 是否为微信订阅号
    isWXdyh: hashQuerys.wxdyh == 1,
    theme: {
      title: defaultTheme.title,
      type: defaultTheme.type
    },
    // 10000 药九九
    // 11000 九州通医药集团微信公众号 12000 九州通客户服务微信服务号 13000 集团官网
    // 14000 灯塔
    // 15000 器械官网
    // 16000 药九九公众号
    // 17000 药九九微信小程序
    // 18000 PC物流官网 19000 物流微信公众号页面
    // 21000 DMS
    // 22000 医药通小程序
    platformGroups: {
      group: ['11000', '12000', '13000', '15000', '18000', '19000'], // 不显示显示店铺列表，会话列表
      group0: ['11000', '12000', '13000', '15000'], // 显示天鹅头像
      group1: ['11000', '12000', '13000', '21000', '22000'], // 显示九州通集团客服名称
      group2: ['15000'], // 不显示联系人工客服按钮
      group3: ['16000'], // 显示药九九平台客服名称
      group4: ['18000', '19000'], // 显示物流头像
      group5: ['10000'], // 显示获取首页资料按钮
    },
    platformNames: {
      name1: '九州通集团客服',
      name2: '九州通医疗信息科技（武汉）有限公司',
      name3: '药九九平台客服',
      name4: '九州通物流客服'
    }
  },
  mutations: {
    setOnline(state, status) {
      state.online = status
    },
    setPageIsVisible(state, visible) {
      state.pageIsVisible = visible
    },
    setTitle(state, str) {
      // 只改变title
      state.theme.title = document.title = str
    },
    setMobile(state, isMobile) {
      state.mobile = isMobile
    },
    setGrayscale(state, { shade, shadeValue }) {
      if (shade) setGrayscaleMark(shade)
      if (shadeValue) setGrayscaleMarkValue(shadeValue)
      if (shade && shadeValue) setGrayscaleData(shade, shadeValue)
    }
  },
  actions: {
    changeTheme({ state, commit }) {
      let type = ''
      if (
        state.platformGroups.group2.includes(hashQuerys.platformId) ||
        state.platformGroups.group4.includes(hashQuerys.platformId)
      ) {
        type = 'blue'
      } else {
        type = hashQuerys.storeId ? 'yjj' : 'jzt'
      }
      const theme = themes[type] || defaultTheme
      if (theme) {
        state.theme.type = document.documentElement.dataset.theme = theme.type
        state.theme.title = document.title = theme.title
        commit('chat/updateUserAvatar', theme.userAvatar)
        commit('chat/updateAgentAvatar', theme.agentAvatar)
      }
    },
    determineDeviceType({ commit }) {
      const deviceType = uaParser().device.type // 获取设备类型
      const osName = uaParser().os.name // 获取系统名称
      const width = window.innerWidth // 获取屏幕宽度
      const isMobileOrTablet =
        deviceType === 'mobile' || deviceType === 'tablet' || ['iOS', 'Android'].includes(osName) || width <= 1024
      commit('setMobile', isMobileOrTablet)
    }
  },
  getters: {
    getPlatformName: state => platformId => {
      if (state.platformGroups.group1.includes(platformId)) {
        return state.platformNames.name1
      }
      if (state.platformGroups.group2.includes(platformId)) {
        return state.platformNames.name2
      }
       if (state.platformGroups.group3.includes(platformId)) {
        return state.platformNames.name3
      }
      if (state.platformGroups.group4.includes(platformId)) {
        return state.platformNames.name4
      }
      return ''
    },
    getPlatformImage: state => platformId => {
      const groupImageMap = [
        { group: state.platformGroups.group0, image: 'grouphead.png' },
        { group: state.platformGroups.group4, image: 'grouphead1.png' }
      ]
      for (const { group, image } of groupImageMap) {
        if (group.includes(platformId)) {
          return require(`@/assets/image/${image}`)
        }
      }
      return ''
    }
  },
  modules: {
    chat: chatStore
  }
})
